export const getAppFromUser = (urlApp, user) => {
  const app: string = urlApp ? urlApp.toLowerCase() : '';
  return user.applications.find(
    (element) => element.uuid.toLowerCase() === app,
  );
};
